import React from 'react'
import { RuleSeverity, Vulnerability } from '../../../../components/shared'
import { Severity, VulnerabilitySeverityBadge } from '../severity'
import { CvssScoringType, Library } from '../../helpers/ui-interfaces'
import { styles } from './drilldown-content-view/styles'
import { getSeverityColor } from './helpers'
import { Organization } from '@contrast-security-inc/base-types'
import { Link } from '@contrast-security-inc/design-system-typography'

interface Props {
  library: Pick<Library, 'vulnerabilities'>
  setSelectedModalVulnerability: React.Dispatch<
    React.SetStateAction<Vulnerability | undefined>
  >
  setVulnerabilityDrawerIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  organization: Organization
}

export const CVEList = ({
  library,
  setSelectedModalVulnerability,
  setVulnerabilityDrawerIsOpen,
  organization
}: Props) => {
  return (
    <>
      {organization && (
        <div data-testid="CVEList">
          {library.vulnerabilities.map((vulnerability) => {
            const severityCode =
              organization.cvssScoringType === CvssScoringType.CVSS3_1 &&
              vulnerability.cvss3SeverityCode &&
              vulnerability.hasCvss3
                ? vulnerability.cvss3SeverityCode
                : vulnerability.severityCode
            if (!severityCode) {
              return <></>
            }
            return (
              <div key={vulnerability.name}>
                <div
                  className={styles.libraryOverviewRiskBodyListItem}
                  key={vulnerability.name}
                  id={vulnerability.name}
                >
                  <VulnerabilitySeverityBadge
                    severity={Severity.fromName(severityCode)}
                  />

                  <div data-testid="CVEScore">
                    <div
                      className={styles.libraryOverviewCVEScore(
                        getSeverityColor(severityCode as RuleSeverity)
                      )}
                    >
                      {Number(
                        organization.cvssScoringType ===
                          CvssScoringType.CVSS3_1 &&
                          vulnerability.cvss3SeverityValue &&
                          vulnerability.hasCvss3
                          ? vulnerability.cvss3SeverityValue
                          : vulnerability.severityValue
                      ).toFixed(1)}
                    </div>
                  </div>

                  <div data-testid="CVETitle">
                    <Link
                      testId={`${vulnerability.name}-link`}
                      className={styles.libraryOverviewCVELink}
                      onClick={() => {
                        setSelectedModalVulnerability(vulnerability)
                        setVulnerabilityDrawerIsOpen(true)
                      }}
                    >
                      {vulnerability.name}
                    </Link>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}
